import axios from 'axios'
import baseUrl from './base-url'
import { getValidUrl } from '../util'

export default function({ state }, { url, data, query, withBaseUrl = true }) {
    if (query)
        url = url + '?' + Object.keys(query).map((q) => (q + '=' + query[q])).join('&')

    url = getValidUrl(url, state)

    const __url = withBaseUrl ? baseUrl + url : url
    return axios.put(__url, data || {}, {
            withCredentials: true
        })
        .then((response) => {
            return response.data
        })
        .catch((error) => {
            console.log(error)
            throw error.response.data
        })
}
